/* Stalwart theme — only the behaviour the design needs.
   Kept deliberately small: hero carousel, gallery, mobile nav, and repointing
   the marketplace link when the variant changes. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- hero carousel: loops, no dead ends ---------- */
  function hero() {
    var track = $('[data-hero-track]');
    if (!track) return;
    var dots = $$('[data-hero-dot]');
    var prev = $('[data-hero-prev]'), next = $('[data-hero-next]');
    var count = dots.length || 1, idx = 0;
    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function paint() {
      if (track.clientWidth) {
        idx = Math.max(0, Math.min(count - 1,
          Math.round(track.scrollLeft / track.clientWidth)));
      }
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === idx ? 'true' : 'false');
      });
    }
    function go(i) {
      i = ((i % count) + count) % count;      /* wrap both directions */
      idx = i;
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      var left = i * track.clientWidth;
      try { track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); }
      catch (e) { track.scrollLeft = left; }
    }
    track.addEventListener('scroll', paint, { passive: true });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    window.addEventListener('resize', paint);
    paint();
  }

  /* ---------- product gallery ---------- */
  function gallery() {
    var main = $('#pdp-main');
    if (!main) return;
    $$('[data-gal-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.setAttribute('src', b.getAttribute('data-gal-thumb'));
        $$('[data-gal-thumb]').forEach(function (x) {
          x.setAttribute('aria-current', x === b ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- marketplace link follows the selected variant ----------
     Variant links are real hrefs, so a page load already points correctly.
     This covers themes or apps that swap the variant without navigating. */
  function marketplace() {
    var data = $('[data-amz-urls]');
    if (!data) return;
    var urls;
    try { urls = JSON.parse(data.textContent); } catch (e) { return; }
    function point(id) {
      var u = urls[String(id)];
      if (!u) return;
      var buy = $('[data-amz-buy]'), rev = $('[data-amz-rev]');
      if (buy && u.buy) buy.setAttribute('href', u.buy);
      if (rev && u.rev) rev.setAttribute('href', u.rev);
    }
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) point(e.detail.variant.id);
    });
    var last = location.search;
    setInterval(function () {
      if (location.search !== last) {
        last = location.search;
        var m = /[?&]variant=(\d+)/.exec(last);
        if (m) point(m[1]);
      }
    }, 300);
  }

  /* ---------- mobile nav ---------- */
  function mobileNav() {
    var btn = $('[data-mnav-open]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      document.body.classList.toggle('sw-mnav-open');
    });
  }

  function boot() { hero(); gallery(); marketplace(); mobileNav(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
